const {
    toNullableBool,
    toNullableString,
    toNullableTrimmedString,
} = require('@/functions/transform');

/**
 * Company level settings stored in the companies_settings database table.
 * The values can all be null if no value was set for that setting.
 * The boolean values in particular default to null on purpose so we can differentiate between default
 * behaviour when no value was selected and falsy values. For example some settings might control things
 * that should happen by default unless "No" has specifically been selected in the Back Office. In that case
 * the default of null is useful to see if it has been answered or not.
 */
class CompanySettings {
    constructor() {
        /**
         * @type {string|null}
         */
        this.charityAddress = null;

        /**
         * @type {string|null}
         */
        this.charityName = null;

        /**
         * @type {string|null}
         */
        this.charityNumber = null;

        /**
         * @type {boolean|null}
         */
        this.enableCrossBranchSelling = null;

        /**
         * Should we enable deposits and orders without payments.
         *
         * @type {boolean|null}
         */
        this.enablePropointDeposits = null;

        /**
         * Should we print a QR code containing the voucher code on Gift Voucher receipts?
         *
         * @type {boolean|null}
         */
        this.enablePropointGiftVoucherQrCode = null;

        /**
         * Should we print QR Codes instead of Barcodes on receipts and tickets?
         *
         * @type {boolean|null}
         */
        this.enablePropointReceiptAndTicketQrCode = null;

        /**
         * Should we use the flow of creating an unpaid order before taking payment?
         *
         * @type {boolean|null}
         */
        this.enablePropointUnconfirmedOrderFlow = null;

        /**
         * @type {boolean|null}
         */
        this.enableWaivers = null;

        /**
         * @type {string|null}
         */
        this.entersoftConfig = null;

        /**
         * The text that should be printed on a receipt or Boca Gift Aid confirmation depending on the
         * printGiftAid* settings.
         *
         * @type {string|null}
         */
        this.giftAidDeclarationForReceipts = null;

        /**
         * @type {boolean|null}
         */
        this.printBranchNameOnProPointReceipts = null;

        /**
         * @type {boolean|null}
         */
        this.printCustomerAddressOnProPointReceipts = null;

        /**
         * @type {boolean|null}
         */
        this.printCustomerNameOnProPointReceipts = null;

        /**
         * @type {boolean|null}
         */
        this.printEventNameOnProPointReceipts = null;

        /**
         * @type {boolean|null}
         */
        this.printGiftAidDeclarationOnPropointBocaReceipts = null;

        /**
         * @type {boolean|null}
         */
        this.printGiftAidDeclarationOnPropointReceipts = null;

        /**
         * @type {boolean|null}
         */
        this.printSalesChannelOnProPointReceipts = null;

        /**
         * @type {boolean|null}
         */
        this.printSessionNameOnProPointReceipts = null;

        /**
         * @type {string|null}
         */
        this.receiptTel = null;

        /**
         * @type {string|null}
         */
        this.receiptEmail = null;

        /**
         * @type {string|null}
         */
        this.receiptWebsite = null;

        /**
         * @type {boolean|null}
         */
        this.restrictPaymentOnAccountToBusinessAccounts = null;
    }

    getHydrationMap() {
        return {
            charityAddress: toNullableTrimmedString,
            charityName: toNullableTrimmedString,
            charityNumber: toNullableTrimmedString,
            enableCrossBranchSelling: toNullableBool,
            enablePropointDeposits: toNullableBool,
            enablePropointGiftVoucherQrCode: toNullableBool,
            enablePropointReceiptAndTicketQrCode: toNullableBool,
            enablePropointUnconfirmedOrderFlow: toNullableBool,
            enableWaivers: toNullableBool,
            entersoftConfig: toNullableString,
            giftAidDeclarationForReceipts: toNullableString,
            printBranchNameOnProPointReceipts: toNullableBool,
            printCustomerAddressOnProPointReceipts: toNullableBool,
            printCustomerNameOnProPointReceipts: toNullableBool,
            printEventNameOnProPointReceipts: toNullableBool,
            printGiftAidDeclarationOnPropointBocaReceipts: toNullableBool,
            printGiftAidDeclarationOnPropointReceipts: toNullableBool,
            printSalesChannelOnProPointReceipts: toNullableBool,
            printSessionNameOnProPointReceipts: toNullableBool,
            receiptEmail: toNullableString,
            receiptTel: toNullableString,
            receiptWebsite: toNullableString,
            restrictPaymentOnAccountToBusinessAccounts: toNullableBool,
        };
    }
}

module.exports = CompanySettings;
